import { Button, Modal } from "react-bootstrap"
import { useEffect, useRef, useState } from "react"

import "./migrate.css"
import request, { postWithResponse } from "../../internal/request"
import { API_ADDR } from "../../App"

export interface MigrationJob {
  id: string
  status?: string
  result?: string
  error?: string
  file_progress?: number
}

interface Props {
  from: string
  to: string
  show: boolean
  onHide?: (() => void) | undefined
}

export default function Migration(props: Props) {

  const [progress, setProgress] = useState(0) // 0 = not started, 1= in progress,  3 = complete, 4 = failed
  const [status, setStatus] = useState("Not yet started")

  const statusRef = useRef<NodeJS.Timer | null>(null)

  useEffect(() => {
    if (props.show) {
      setStatus("Not yet started")
      setProgress(0)
    }
  }, [props.show])

  function start() {
    // Trigger a migration
    postWithResponse<MigrationJob>(`${API_ADDR()}/api/migrate?from=${props.from}&to=${props.to}`)
      .then((res) => {
        setStatus(res.status ?? "No status info returned")
        setProgress(1)

        if (res.status === "Requested") {
          // Start monitoring for updates
          statusRef.current = setInterval(() => {
            checkStatus(res.id)
          }, 2000)
        }
      })
      .catch((err) => {
        setProgress(4)
        setStatus(`Error: ${err}`)
      })
  }

  function checkStatus(id: string) {
    request<MigrationJob>(`${API_ADDR()}/api/migrate?id=${id}`)
      .then((res) => {
        console.log("File progress = ", res.file_progress ?? "undefined or null")
        if (res.status === "Complete") {
          if (statusRef.current)
            clearInterval(statusRef.current)

          setStatus(`${res.result ?? "No result returned"}${res.error ? `, with error: ${res.error}` : ""}`)
          setProgress(3)
        } else {
          let status = res.status ?? "No status info returned"
          if ((res.file_progress ?? 0) > 0)
            status = `${status} [${res.file_progress}%]`

          setStatus(status)
        }

      })
      .catch((err) => {
        if (statusRef.current)
          clearInterval(statusRef.current)

        setProgress(4)
        setStatus(`Error: ${err}`)
      })
  }

  return <Modal
    show={props.show}
    size="lg"
    centered
    backdrop="static"
    keyboard={false}
  >
    <Modal.Header>
      <Modal.Title>
        <div>Migrate from {props.from} to {props.to}</div>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      Status: {status}
    </Modal.Body>
    <Modal.Footer>
      <Button variant={progress < 4 ? "secondary" : "primary"} onClick={props.onHide}>{progress < 3 ? "Cancel" : "Done"}</Button>
      {progress === 0
        ? <Button onClick={() => start()}>Start</Button>
        : null
      }
    </Modal.Footer>
  </Modal>
}